import template from './myLoansMobileFilters.html';
import controller from './myLoansMobileFilters.controller';
import './myLoansMobileFilters.scss';

let myLoansMobileFiltersComponent = {
  restrict: 'E',
  bindings: {
    objectStatesFilter: '<',
    filterByStatus: '&',
  },
  template,
  controller
};

export default myLoansMobileFiltersComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansMobileFilters/myLoansMobileFilters.component.js